import { createAction, props } from '@ngrx/store';
import { RemovedItemNotices } from '../../models/removed-item-notice';

export const getRemovedItemNotices = createAction('[Removed Item Notices] Get Removed Item Notices');

export const getRemovedItemNoticesSuccess = createAction(
  '[Removed Item Notices] Get Removed Item Notices Success',
  props<{ notices: RemovedItemNotices }>()
);

export const getRemovedItemNoticesFailure = createAction(
  '[Removed Item Notices] Get Removed Item Notices Failure',
  props<{ error: unknown }>()
);
